class InstagramFeed extends HTMLElement {
  constructor() {
    super();

    this.urlInst = this.dataset.instagram;
    this.url =
      "https://api.nfcube.com/feed/v6?limit=10&account=homewell-studio.myshopify.com&fu=0&fid=0&hash=01806a7e29ed6a42bbc6aaff7cf43409&locale=en";
  }

  connectedCallback() {
    this.renderElement();
  }

  async renderElement() {
    try {
      const response = await fetch(this.url, {
        method: "POST",
      });

      const result = await response.json();
      const posts = result.data || [];

      this.createElements([...posts, ...posts]);

      const slider = this.querySelector("custom-slider");

      if (slider && typeof slider.updateSlider === "function") {
        slider.updateSlider();
      }
    } catch (error) {
      console.error("Instagram feed error:", error);
    }
  }

  createElements(elements) {
    const wrapper = this.querySelector(".swiper-wrapper");

    if (!wrapper) return;

    elements.forEach((el) => {
      const urlImg = el?.images?.standard_resolution?.url;

      if (!urlImg) return;

      const swiperSlide = document.createElement("div");
      swiperSlide.classList.add("swiper-slide", "collection-item");

      const swiperSlideWrap = document.createElement("div");
      swiperSlideWrap.classList.add("swiper-slide__wrap");

      const imageDiv = document.createElement("div");
      imageDiv.classList.add("image");

      const linkInstagram = document.createElement("a");
      linkInstagram.setAttribute("target", "_blank");
      linkInstagram.setAttribute("rel", "noopener noreferrer");
      linkInstagram.href = this.urlInst || el.link || "#";

      const imageWrap = document.createElement("div");
      imageWrap.classList.add("image__wrap");

      const imgElement = document.createElement("img");
      imgElement.src = urlImg;
      imgElement.alt = el?.caption?.text || "Instagram image";
      imgElement.loading = "lazy";

      imageWrap.appendChild(imgElement);

      imageDiv.appendChild(linkInstagram);
      imageDiv.appendChild(imageWrap);

      swiperSlideWrap.appendChild(imageDiv);
      swiperSlide.appendChild(swiperSlideWrap);

      wrapper.appendChild(swiperSlide);
    });
  }
}

customElements.define("instagram-feed", InstagramFeed);